/*global reviewAfterDropOffExist, dchScore, myModal, inputDirectionChange */

var review = {
    init: function() {
        const FORM_SUBMITTED = 1;
        const submitButton = $('.submit-review');
        $('.modal-close').on('click', () => {
            setTimeout(() => {
                window.location.href = _d.url.host;
            }, 1000);
        });

        if (typeof reviewAfterDropOffExist !== 'undefined') {

            if (reviewAfterDropOffExist) {
                submitButton.remove();

                _d.reviewAfterDropOffExist = true;
                setTimeout(function() {
                    myModal.staticModal('alreadyAddedFeedbackModal');
                }, 400);
            }
        }

        submitButton.on('click', function(e) {
            var valid = true;
            e.preventDefault();

            review.btnDisable();

            $('.rate-error').removeClass('show');
            $('.rw-error').stop().slideUp();

            $('.rating-item').each(function() {
                var $this = $(this);
                var requiredRadioFieldsExist = $this.find('input[type="radio"][data-required="true"]').length > 0;
                var requiredRadioFieldsChecked = $this.find('input[type="radio"][data-required="true"]:checked').length > 0;

                if (requiredRadioFieldsExist && !requiredRadioFieldsChecked) {
                    $this.parents('.feedback-items').find('.rate-error').first().addClass('show');
                    valid = false;
                }
            });

            $('.review-comment').each(function() {
                var $this = $(this);

                if ($this.hasClass('no-validation')) {
                    return;
                }

                if ($this.val().length === 0) {
                    $this.parent().find('.rate-error').addClass('show');
                    valid = false;
                }
            });

            if (!review.yesNo_validate('.expected-car')) {
                valid = false;
            }

            if (!review.yesNo_validate('.contact-support')) {
                valid = false;
            }

            if (review.recheckFilesCheckbox() !== true) {
                valid = false;
            }

            if (!valid) {
                review.scrollToError();
            }

            if (valid) {
                $('#form-submitted').val(FORM_SUBMITTED);
                $.postJSON(_d.url.reservation.registerReview, $('#review-form').serialize(), function(response) {
                    if (!response.error) {
                        var experience  = $('.dch-rating:checked').val();

                        myModal.staticModal('thankYouModal');

                        if (experience >= 8) {
                            $('.share-info').addClass('show');
                            $('.review-info-action').hide();
                            $('.add-comment').each(function() {
                                var comment = $(this).val();

                                if (comment.length > 0) {
                                    $('.comment-block').append('<p class="user-comment">' + comment + '</p>').addClass('show');
                                }
                            });
                        }

                        review.btnInactive();
                    } else {
                        review.btnEnable(true);
                    }
                });
            } else {
                review.btnEnable();
            }
        });

        $(document).on('change', '.feedback-rate', function() {
            var error = $(this).data('error');
            $(this).parents('.feedback-items').next().slideDown();
            $('.rate-error.' + error).removeClass('show');
        });

        $('.supplier-rating').on('click', function() {
            var supplierCriterion = 7,
                selectedCriterion = 0;

            $('.rating-item.small').each(function() {
                if ($(this).find('.supplier-rating').is(':checked') ) {
                    selectedCriterion = selectedCriterion + 1;
                }
            });

            if (supplierCriterion === selectedCriterion) {
                $(this).parents('.feedback-items').next().slideDown();
                $('.supplier-error').removeClass('show');
            }
        });

        document.getElementById('filesAgree').addEventListener('click', () => {
            if (review.validateFiles()) {
                review.filesCheckboxHideError();
            }
        });

        review.yesNo_onChange('.expected-car');
        review.yesNo_onChange('.contact-support');

        if (typeof dchScore !== 'undefined' && (typeof reviewAfterDropOffExist !== 'undefined' && !reviewAfterDropOffExist)) {
            $('.constant-question.satisfaction .dch-rating[value=' + dchScore + ']').prop('checked', true).trigger('change');
        }

        $('textarea').each(function() {
            inputDirectionChange.onChangeAction(this);
        });

        review.unsubscribe();
    },
    btnDisable: function() {
        var btn = $('.submit-review');
        btn.toggleClass('loading').attr('disabled', 'disabled').text(btn.data('loading'));
    },
    btnEnable: function(showError) {
        var btn = $('.submit-review'),
            errorHandler = $('.rw-error');

        btn.toggleClass('loading').removeAttr('disabled').text(btn.data('text'));

        if (typeof showError !== 'undefined') {
            errorHandler.stop().slideDown();
        }
    },
    btnInactive: function() {
        var btn = $('.submit-review');
        btn.toggleClass('loading').text(btn.data('text'));
    },
    saveFeedback: function() {
        $.postJSON(_d.url.reservation.registerReview, $('#review-form').serialize());
    },
    unsubscribe: function() {
        var btn = $('#unsubscribeBtn');

        $('.unsubscribe-item').on('change', function() {
            var field = $('#uc-box');

            if (parseInt($(this).val()) === 3) {
                field.show();
            } else {
                field.hide();
            }
        });

        $('#unsubscribeReviewAfterDropOff').validate({
            ignore: [],
            errorClass: 'error',
            focusInvalid: false,
            onfocusout: true,
            errorElement: 'div',
            rules: {
                unsubscribe_reason: {
                    required: true
                },
                unsubscribe_comment: {
                    required: function() {
                        return $('.unsubscribe-item:checked').val() === '3';
                    }
                }
            },
            errorPlacement: function(error, element) {
                if (element.attr('name') === 'unsubscribe_reason') {
                    $('#ur-error').html(error);
                } else {
                    $(element).next().html(error);
                }
            },
            invalidHandler: function() {
                btn.removeClass('loading');
            },
            submitHandler: function() {
                btn.prop('disabled', true);

                $.postJSON(_d.url.reservation.unsubscribe, $('#unsubscribeReviewAfterDropOff').serialize(), function(response) {
                    if (!response.error) {
                        window.location = _d.url.reservation.unsubscribeSuccessfully + '/' + response.data.unsubscribe_number + '/' + btoa(response.data.email);
                    } else {
                        btn.removeClass('loading').prop('disabled', false);
                    }
                });
            }
        });


        $('.resubscribe').on('click', function(e) {
            e.preventDefault();
            var that = $(this);

            if (that.hasClass('clicked')) {
                return false;
            }

            that.addClass('clicked');
            $.postJSON(_d.url.reservation.resubscribe, $('#resubscribeReviewAfterDropOff').serialize(), function(response) {
                if (!response.error) {
                    myModal.staticModal('resubscribeThanksModal');
                } else {
                    btn.removeClass('loading clicked');
                }
            });
        });
    },
    validateFiles: function() {
        const filesAmount = $('ul.filepond--list li').length;
        const checkbox = document.getElementById('filesAgree');
        const checkboxStatus = checkbox !== null ? checkbox.checked === true : false;

        return !(filesAmount > 0 && checkboxStatus !== true);
    },
    recheckFilesCheckbox: function() {
        if (this.validateFiles()) {
            review.filesCheckboxHideError();
            return true;
        } else {
            review.filesCheckboxShowError();
            return false;
        }
    },
    filesCheckboxShowError: function() {
        $('#filesAgree').next('label').addClass('error');
        $('#files-agree-error').addClass('show');
    },
    filesCheckboxHideError: function() {
        $('#filesAgree').next('label').removeClass('error');
        $('#files-agree-error').removeClass('show');
    },
    yesNo_setRatingRequiredStatus: function(selector, status) {
        const ratingFields = $(selector+' .feedback-rating > input');
        if (ratingFields.length) {
            ratingFields.each(function() {
                $(this).attr('data-required', status);
            });
        }
    },
    yesNo_onChange: function(selector) {
        $(selector).children('.radio').change(function() {

            var checkBoxValue = $(this).val();
            $(selector).children('.radio').removeClass('error');

            if (checkBoxValue === 'yes') {
                review.yesNo_toggleSubsection(selector, 'yes', true);
            } else {
                review.yesNo_toggleSubsection(selector, 'yes', false);
            }

            if (checkBoxValue === 'no') {
                review.yesNo_toggleSubsection(selector, 'no', true);
            } else {
                review.yesNo_toggleSubsection(selector, 'no', false);
            }

            $(selector+'-error').removeClass('show');
        });
    },
    yesNo_validate: function(selector) {
        if ($(selector+' .radio').length && $(selector+' .radio').is(':checked') === false) {
            $(selector).children('.radio').addClass('error');
            $(selector+'-error').addClass('show');

            return false;
        }

        return true;
    },
    yesNo_toggleSubsection: function(selector, value, show) {

        const ratingSelector = selector+'-'+value+'-rating';
        const textSelector = selector+'-'+value+'-text';

        if (show) {
            $(textSelector).removeClass('d-none');
            $(ratingSelector).removeClass('d-none');
            review.yesNo_setRatingRequiredStatus(ratingSelector, true);

            return;
        }

        $(textSelector).addClass('d-none');
        $(ratingSelector).addClass('d-none');
        review.yesNo_setRatingRequiredStatus(ratingSelector, false);
    },
    scrollToError: function() {
        $('html,body').animate({
            scrollTop: $('.rate-error.show:first').closest('.review.feedback').offset().top - 80
        }, 700);
    }
};
